import { type ITagModel } from 'tno-core';

export const defaultTag: ITagModel = {
  id: 0,
  name: '',
  description: '',
  isEnabled: true,
  sortOrder: 0,
  code: '',
};
